var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:Math.random(),staticClass:"custom-checkbox",class:{ disabled: _vm.isDisabled },on:{"click":_vm.toggleCheck}},[_c('input',{attrs:{"type":"checkbox","disabled":_vm.isDisabled},domProps:{"checked":_vm.isChecked},on:{"change":_vm.toggleCheck}}),_c('span',{staticClass:"checkmark"})])
}
var staticRenderFns = []

export { render, staticRenderFns }